"use strict";

angular.module('rmSidebar')
	.controller('AppSidebarCtrl', require('./sidebar_ctrl'));